import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	HostBinding,
	HostListener,
	OnDestroy,
	OnInit,
	QueryList,
	ViewChild,
	ViewChildren,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as fromQuickLink from '@app/layout/header/store/quick-link';
import * as fromRouter from '@app/root-store/router';
import * as fromUiScreen from '@app/root-store/ui/screen';
import { select, Store } from '@ngrx/store';
import { RdsDropdownDirective, RdsHeaderSearchbarComponent, RdsMenuTriggerDirective } from '@rds/angular-components';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SubSink } from 'subsink';
import * as fromHeader from '../../store/header';
import * as fromHeaderActions from '../../store/header/header.actions';
import { environment } from '@env/environment';
@Component({
	selector: 'rh-standalone-newsletter-header',
	templateUrl: './standalone-newsletter-header.component.html',
	styleUrls: ['./standalone-newsletter-header.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [{ provide: Window, useValue: window }],
})
class StandaloneNewsletterHeaderComponent implements OnInit, OnDestroy {
	@HostBinding('style.top') top: string = '0';
	@HostBinding('style.opacity') opacity: string = '1';

	@HostListener('window:scroll')
	scrolled() {
		if (!this.forceClose) {
			let html = document.querySelector('html');

			if (this.scrollPosition > this.window.scrollY && !html.className) {
				// this.opacity = '1';
				this.top = '0';
				this.store$.dispatch(fromHeaderActions.setHeaderVisible({ visible: true }));
			} else if (this.window.scrollY > 119) {
				this.top = '-120px';
				// this.opacity = '0'
				this.store$.dispatch(fromHeaderActions.setHeaderVisible({ visible: false }));
				this.gcsMenuTrigger.closeMenu();
				// this.appMenuTrigger.closeMenu();
				this.topTriggers.map((t) => t.closeMenu());
				this.bottomTriggers.map((t) => t.closeMenu());
			}
		}
		this.scrollPosition = this.window.scrollY;
	}

	@ViewChild('searchSuggestions', { static: true }) searchSuggestions: RdsDropdownDirective;
	@ViewChild('searchBar', { static: true }) searchBar: RdsHeaderSearchbarComponent;
	@ViewChildren('bottomTrigger') bottomTriggers: QueryList<RdsMenuTriggerDirective>;
	@ViewChildren('topTrigger') topTriggers: QueryList<RdsMenuTriggerDirective>;
	@ViewChild('gcsMenuTrigger', { static: true }) gcsMenuTrigger: RdsMenuTriggerDirective;
	@ViewChild('appMenuTrigger', { static: true }) appMenuTrigger: RdsMenuTriggerDirective;

	scrollPosition = this.window.scrollY;

	private subs: SubSink = new SubSink();

	private forceClose = false;

	public isMobile: true | false;
	public isMobile$: Observable<boolean> = this.store$.pipe(
		select(fromUiScreen.selectIsMobile),
		tap((res) => (this.isMobile = res))
	);



	public forceClose$ = this.store$.pipe(select(fromHeader.selectForceClose));



	ngOnInit(): void {


		this.subs.sink = this.activatedRoute.queryParams.subscribe((params) => {
			if (params.phrase) {
				// this.searchBar.searchValue = params.phrase;
				// (this.searchBar.searchInput.nativeElement as HTMLInputElement).value = params.phrase;
				this.store$.dispatch(fromHeaderActions.setPhrase({ phrase: params.phrase }));
				this.store$.dispatch(fromHeaderActions.loadSuggestions({ text: params.phrase }));
			} else {
				// this.searchBar.searchValue = '';
				// (this.searchBar.searchInput.nativeElement as HTMLInputElement).value = '';
			}
		});
		this.subs.sink = this.forceClose$.subscribe((close) => {
			this.forceClose = close;
			if (close) {
				this.top = '-125px';
				this.opacity = '0';
			} else {
				this.top = '0';
				this.opacity = '1';
			}
		});
	}

	logoClick() {
		this.store$.dispatch(fromRouter.goOutsideInCurrentTab({ url: environment.myRocheLink }));
	}
	ngOnDestroy(): void {
		this.subs.unsubscribe();
	}

	constructor(
		private window: Window,
		private store$: Store,
		private activatedRoute: ActivatedRoute,
		private router: Router,
		private cdr: ChangeDetectorRef
	) {}
}

export default StandaloneNewsletterHeaderComponent
